import { testimonials } from '@/mocks/testimonials';

export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-32 h-32 opacity-[0.04] pointer-events-none">
        <svg viewBox="0 0 200 200" className="w-full h-full">
          <path
            d="M20 180 Q60 20 120 60 Q160 100 100 140 Q50 180 20 180Z"
            fill="currentColor"
            className="text-foreground-950"
          />
        </svg>
      </div>

      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="relative max-w-5xl mx-auto">
          <div className="bg-background-950 rounded-[40px] overflow-hidden flex flex-col lg:flex-row">
            <div className="lg:w-[38%] relative -ml-4 lg:-ml-12 my-4 lg:my-8">
              <div className="h-[300px] lg:h-[480px] rounded-[30px] overflow-hidden">
                <img
                  src={testimonials[0].image}
                  alt="911爆料网资深用户"
                  title="911爆料网用户证言"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>

            <div className="lg:w-[62%] flex flex-col justify-center px-6 lg:px-10 py-8 lg:py-12">
              <div className="text-6xl text-accent-300/40 leading-none mb-4 font-serif">&ldquo;</div>
              <blockquote className="text-lg md:text-xl text-background-50 leading-relaxed">
                {testimonials[0].quote}
              </blockquote>
              <div className="mt-6">
                <p className="text-sm font-semibold text-background-50">
                  {testimonials[0].author}
                </p>
                <p className="text-xs text-background-50/50 mt-0.5">
                  {testimonials[0].authorTitle}
                </p>
              </div>
              <div className="mt-6">
                <button
                  type="button"
                  className="px-6 py-2.5 text-sm font-semibold bg-accent-200 text-accent-900 rounded-full hover:bg-accent-300 transition-colors cursor-pointer whitespace-nowrap"
                  onClick={() => {
                    const el = document.getElementById('hot-leaks');
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  查看更多爆料
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}